<template>
  <TemplateContentSubNav>
    <template #navigation>
      <DisplaySection gap="xl" tag="nav">
        <NavigationLibraryBooksSlider
          v-if="!isAboveL && isInUserContent"
          variant="outlined"
        />
        <NavigationButtonLibraryNomad v-if="isAboveL && isInUserContent" />
        <NavigationLibraryBooksList v-if="isAboveL && isInUserContent" />
        <NavigationButtonBackFromLinks v-if="!isInUserContent" :links="links" />
      </DisplaySection>
    </template>

    <LbViewRouter />
    <div class="actions">
      <LbAddContent
        class="add-content"
        :children="libraryBook ? [libraryBook] : library.children"
        :auto-redirect="isInUserContent"
      />
    </div>
  </TemplateContentSubNav>
</template>
<script lang="ts" setup>
const { libraryManager } = inject(INJECT_LIBRARY_PAGE_OR_FORM);

const { greaterOrEqual } = useEvaBreakpoints();

const isAboveL = greaterOrEqual('l');

const { library, libraryBook, links } = libraryManager;

if (library.value) useAppEventLibraryBox(library.value);

useWebsiteHead({
  title: `Nomad+ - ${library?.value?.title || libraryBook?.value?.metaTitle}`,
});

const { all: allContents } = useContentsForUserType(ContentUserType.Default);

const isInUserContent = computed(() => {
  if (!libraryBook.value) return false;
  return (
    allContents.value.find((content) => content.id === libraryBook.value.id) !==
    null
  );
});
</script>
<style lang="scss" scoped>
.actions {
  padding: var(--gap_n) 0;
}
</style>
